import { css, StyleSheet } from 'aphrodite';
import * as React from 'react';
import * as barForPercent from '../../lotties/bar_for_percent.json';
import * as percentForBar from '../../lotties/percent_for_bar.json';
import { Colors } from '@lean-body/src/view/styles/variables';
import { DiagnosisStepFooter } from '../molecules';
import { LottieIcon } from '../atoms/icons/lottie_icon';
const ANALYSIS_ITEMS = ['生活リズムを分析中', '運動時間・強度を分析中', 'あなた専用のプランを作成中'];
const REVIEW_IMAGES = [
    '/assets/images/onboarding/user_review_1.png',
    '/assets/images/onboarding/user_review_2.png',
    '/assets/images/onboarding/user_review_3.png',
];
export const MatchingAssessmentDiagnosisPlanAnalyzing = ({ onCompleteAnalyzing }) => {
    const [activeBarIndex, setActiveBarIndex] = React.useState(0);
    const [completedBarCount, setCompletedBarCount] = React.useState(0);
    const [currentReviewImageIndex, setCurrentReviewImageIndex] = React.useState(0);
    const handleBarComplete = (barIndex) => {
        if (barIndex !== activeBarIndex || completedBarCount > barIndex) {
            return;
        }
        const nextCompletedCount = barIndex + 1;
        setCompletedBarCount(nextCompletedCount);
        setCurrentReviewImageIndex(Math.min(nextCompletedCount, REVIEW_IMAGES.length - 1));
        if (barIndex < ANALYSIS_ITEMS.length - 1) {
            setActiveBarIndex(barIndex + 1);
        }
    };
    const isFooterVisible = completedBarCount >= ANALYSIS_ITEMS.length;
    return (React.createElement("div", { className: css(styles.container) },
        React.createElement("div", { className: css(styles.analysisSection) },
            React.createElement("div", { className: css(styles.title) }, "\u56DE\u7B54\u3092\u3082\u3068\u306B\u5206\u6790\u3057\u3066\u3044\u307E\u3059..."),
            React.createElement("div", { className: css(styles.analysisList) }, ANALYSIS_ITEMS.map((label, index) => (React.createElement("div", { key: label, className: css(styles.analysisRow) },
                React.createElement("div", { className: css(styles.analysisHeader) },
                    React.createElement("div", { className: css(styles.analysisLabel) }, label),
                    React.createElement(LottieIcon, { classObject: styles.percentLottie, lottieData: percentForBar, loop: false, isPaused: index > activeBarIndex })),
                React.createElement(LottieIcon, { classObject: styles.barLottie, lottieData: barForPercent, loop: false, isPaused: index > activeBarIndex, onComplete: () => handleBarComplete(index) })))))),
        React.createElement("div", { className: css(styles.reviewSection) },
            React.createElement("div", { className: css(styles.reviewTitle) },
                "\u78BA\u304B\u306A\u52B9\u679C\u3092\u5B9F\u611F\u3057\u305F\u3068\u3044\u3046\u58F0\u304C",
                React.createElement("br", null),
                '＼　　続々届いています！　　／'),
            React.createElement("img", { className: css(styles.reviewImage), src: REVIEW_IMAGES[currentReviewImageIndex], alt: "" })),
        isFooterVisible && React.createElement(DiagnosisStepFooter, { isDisabled: false, onNext: onCompleteAnalyzing, buttonText: "\u6B21\u3078" })));
};
const styles = StyleSheet.create({
    container: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 40,
    },
    analysisSection: {
        width: '100%',
        maxWidth: 327,
    },
    title: {
        fontSize: 16,
        lineHeight: 1,
        color: Colors.TextDark,
        textAlign: 'center',
        marginBottom: 32,
    },
    analysisList: {
        display: 'flex',
        flexDirection: 'column',
        gap: 14,
    },
    analysisRow: {
        display: 'flex',
        flexDirection: 'column',
        gap: 8,
    },
    analysisHeader: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
    },
    analysisLabel: {
        fontSize: 12,
        fontWeight: 'bold',
        lineHeight: 1,
        color: Colors.TextDark,
    },
    percentLottie: {
        width: 37,
        height: 15,
    },
    barLottie: {
        width: 327,
        borderRadius: 10,
        overflow: 'hidden',
    },
    reviewSection: {
        width: '100%',
        maxWidth: 327,
    },
    reviewTitle: {
        color: Colors.Accent,
        fontSize: 16,
        fontWeight: 'bold',
        lineHeight: 1.6,
        letterSpacing: 1.28,
        textAlign: 'center',
        marginBottom: 12,
    },
    reviewImage: {
        borderRadius: 20,
        overflow: 'hidden',
        width: '100%',
        display: 'block',
    },
});
